/// <reference path="controls.module.ts" />

module Meevo.Components.Controls {
  export class MeevoStateField implements angular.IDirective {
    restrict = "E";
    require = "ngModel";
    scope = {
      ngModel: "=ngModel",
      contentKey: "@",
      disabled: "=ngDisabled",
      required: "=ngRequired",
      change: "&ngChange", 
      tabIndex: "=?",
      country: "=",
      stateLength: "="
    };

    templateUrl = "app/components/controls/stateTemplate.html";

    link = (scope: any, element: JQuery, attrs: angular.IAttributes, ngModel: angular.INgModelController) => {
        var $timeout = this.$timeout;

        //this is account for the $parent not being updated by the time changeLocal is called
        //the time forces the change function run in the next digest cycle
        scope.changeLocal = function () {
            if (scope.change) {
                $timeout(function () {
                    scope.change();
                });
            }
        }

        //used for validating the form in case of a country type of other
        scope.$watch('ngModel', ngModel => {
            if (scope.country && scope.country == 'OTHER') {
                if (ngModel) {
                    if (ngModel.length > scope.stateLength) {
                        scope.isValid = false;
                    }
                    else {
                        scope.isValid = true;
                    }
                }
                else {
                    scope.isValid = true;
                }
            }
        }) 
    }

    constructor(
        private $timeout
    ) { }

    static factory(): angular.IDirectiveFactory {
        let directive = ($timeout) => {
            return new MeevoStateField($timeout);
        };
        directive.$inject = ['$timeout']
      return directive;
    }
  }

  angular.module("meevo.components.controls")
    .directive("meevoStateField", MeevoStateField.factory());
}